import { createRouter, createWebHistory } from 'vue-router'
import HomeComponent from '../views/HomeComponent.vue'
import PrivacyComponent from '../views/PrivacyComponent.vue'
import TermsComponent from '../views/TermsComponent.vue'
import SupportComponent from '../views/SupportComponent.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomeComponent
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutComponent.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: PrivacyComponent
  },
  {
    path: '/terms',
    name: 'Terms',
    component: TermsComponent
  },
  {
    path: '/support',
    name: 'Support',
    component: SupportComponent
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
